import { CampaignAnalyticsReport } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { ChartWithBackgroundOptions } from './chart-with-background';
import { sortBy } from '@utils/arrays';

export const proximityToHomeChartData = (
  proximityToHome: CampaignAnalyticsReport['proximityToHome']
): ChartWithBackgroundOptions['chartData'] =>
  proximityToHome.visible
    ? proximityToHome.data.toSorted(sortBy('sortIndex', 'desc')).map(data => ({
        name: data.name,
        value: data.value * 100,
      }))
    : [];
